var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('img',{staticStyle:{"width":"300px","margin-top":"-80px"},attrs:{"src":require("../../../../static/images/404/notfind.png")}})])
}]

export { render, staticRenderFns }